class CustomVariantSelector {
  constructor() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.initCustomSelects();
  }

  bindEvents() {
    document.addEventListener('click', this.closeAllSelect.bind(this));
    document.addEventListener('shopify:section:load', () => this.initCustomSelects());
    document.addEventListener('shopify:block:select', () => this.initCustomSelects());
    
    // Listen for variant updates to reinitialize custom dropdowns
    document.addEventListener('variant:update', (event) => {
      // Small delay to ensure DOM has been updated
      setTimeout(() => this.initCustomSelects(), 50);
    });
    
    // Also listen for variant selected events as a backup
    document.addEventListener('variant:selected', (event) => {
      setTimeout(() => this.initCustomSelects(), 50);
    });
    
    // Listen for section morphing events
    document.addEventListener('section:morphed', () => {
      setTimeout(() => this.initCustomSelects(), 50);
    });
  }

  initCustomSelects() {
    const customSelects = document.getElementsByClassName("variant-option__select-wrapper");
    
    Array.from(customSelects).forEach(wrapper => {
      // Skip if already initialized and still has custom elements
      if (wrapper.classList.contains('custom-select-initialized') && 
          wrapper.querySelector('.select-selected')) return;
      
      // Clear existing custom UI elements if any
      const existingSelected = wrapper.querySelector('.select-selected');
      const existingItems = wrapper.querySelector('.select-items');
      if (existingSelected) existingSelected.remove();
      if (existingItems) existingItems.remove();

      const select = wrapper.querySelector("select");
      if (!select) return;

      // Mark as initialized
      wrapper.classList.add('custom-select-initialized');
      wrapper.classList.add('custom-select');

      // Create custom selected item
      const selectedOption = document.createElement("DIV");
      selectedOption.setAttribute("class", "select-selected");
      selectedOption.innerHTML = select.options[select.selectedIndex].innerHTML;
      wrapper.appendChild(selectedOption);

      // Create custom options list
      const optionsList = document.createElement("DIV");
      optionsList.setAttribute("class", "select-items select-hide");

      // Include all options
      Array.from(select.options).forEach((option, index) => {        
        const optionDiv = document.createElement("DIV");
        optionDiv.innerHTML = option.innerHTML;
        optionDiv.setAttribute('data-value', option.value);
        
        // Copy all data attributes from the original option
        Object.keys(option.dataset).forEach(key => {
          optionDiv.setAttribute(`data-${key}`, option.dataset[key]);
        });
        
        // Check availability and add appropriate classes
        let optionClass = '';
        if (index === select.selectedIndex) {
          optionClass = "same-as-selected";
        }
        
        // Add unavailable class if option is not available
        if (option.dataset.optionAvailable === 'false' || option.textContent.includes('- Unavailable')) {
          optionClass += ' option-unavailable';
        }
        
        if (optionClass.trim()) {
          optionDiv.setAttribute("class", optionClass.trim());
        }

        optionDiv.addEventListener("click", (e) => {
          const originalSelect = wrapper.querySelector("select");
          const selectedDisplay = optionDiv.parentNode.previousSibling;

          // Update native select and trigger change event
          originalSelect.value = optionDiv.getAttribute('data-value');
          originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

          // Update custom UI
          selectedDisplay.innerHTML = optionDiv.innerHTML;
          
          // Update selected styling
          const siblings = optionDiv.parentNode.getElementsByTagName("div");
          Array.from(siblings).forEach(sib => sib.removeAttribute("class"));
          optionDiv.setAttribute("class", "same-as-selected");

          // Close dropdown
          selectedDisplay.click();
        });

        optionsList.appendChild(optionDiv);
      });

      wrapper.appendChild(optionsList);

      // Add click handler to selected item
      selectedOption.addEventListener("click", (e) => {
        e.stopPropagation();
        this.closeAllSelect(selectedOption);
        selectedOption.nextSibling.classList.toggle("select-hide");
        selectedOption.classList.toggle("select-arrow-active");
      });
    });
  }

  closeAllSelect(elmnt) {
    const selectItems = document.getElementsByClassName("select-items");
    const selectedItems = document.getElementsByClassName("select-selected");
    const arrNo = [];

    Array.from(selectedItems).forEach((item, index) => {
      if (elmnt === item) {
        arrNo.push(index);
      } else {
        item.classList.remove("select-arrow-active");
      }
    });

    Array.from(selectItems).forEach((item, index) => {
      if (!arrNo.includes(index)) {
        item.classList.add("select-hide");
      }
    });
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  window.customVariantSelector = new CustomVariantSelector();
});